<template>
  <div>

    <h2>{{ $t('title.' + action + '.user') }}</h2>

    <el-tabs v-model="currentTab">

      <el-tab-pane :label="$t('tab.details')">

        <el-row :gutter="40">

          <el-col :span="12" :md="12" :sm="24" :xs="24">

            <user-form :user="user" />

          </el-col>

        </el-row>

      </el-tab-pane>

      <el-tab-pane v-if="!user.new" :label="$t('tab.serverAccesses')">

        <el-row :gutter="40">

          <el-col :span="12" :md="12" :sm="24" :xs="24">

            <el-table
              :data="servers"
              border
              width="100%">

              <el-table-column
                prop="fqdn"
                :label="$t('header.fqdn')"
              />

              <el-table-column :label="$t('header.userLevel')">

                <template scope="scope">

                  <data-form
                    v-if="selectedUserLevels[scope.row.id]"
                    :entity="selectedUserLevels[scope.row.id]"
                    :fields="serverAccessFields"
                    @change="(userLevelId) => userLevelSelected(scope.row.id, userLevelId)"
                    hide-buttons
                  />

                </template>

              </el-table-column>

            </el-table>

            <div style="margin-top: 15px">

              <el-button
                type="primary"
                size="large"
                @click="submitUserLevels"
                :loading="isLoading">{{ $t('button.submit' ) }}</el-button>

            </div>

          </el-col>

        </el-row>

      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>
import UserForm from './UserForm.vue'

import { post } from 'providers/http'
import findAll from 'service/findAll'

export default {
  name: 'user-details',
  data () {
    return {
      currentTab: null,
      selectedUserLevels: {},
      isLoading: false,
      query: null
    }
  },
  computed: {
    user () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true }
      }

      return this.$store.getters['users/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.user.new ? 'create' : 'edit'
    },
    serverAccessFields () {
      return {
        'userLevelId': {
          type: 'select',
          options: this.userLevels.map(ul => ({ value: ul.id, label: ul.name }))
        }
      }
    }
  },
  methods: {
    async submitUserLevels () {
      const data = {
        userId: this.user.id,
        userLevels: Object.entries(this.selectedUserLevels).reduce((acc, [key, value]) => ({ ...acc, [key]: value.userLevelId }), {})
      }

      try {
        await post('api/v1/users/set-user-levels', data)
        this.showSuccess('user-levels-updated')
      }
      catch (err) {
        console.error(err)
      }
    },
    userLevelSelected (serverId, userLevelId) {
      this.selectedUserLevels[serverId] = userLevelId
    },
    recomputeSelectedUserLevels () {
      this.servers.forEach(s => {
        const userLevelId = ((this.user.serverAccesses || []).find(sa => sa.server_id === s.id) || {}).user_level_id

        this.selectedUserLevels[s.id] = { userLevelId }
      })
    }
  },
  beforeMount () {
    this.recomputeSelectedUserLevels()
  },
  watch: {
    servers () {
      this.recomputeSelectedUserLevels()
    },
    user () {
      this.recomputeSelectedUserLevels()
    }
  },
  mixins: [
    findAll('servers'),
    findAll('user-levels', 'userLevels')
  ],
  components: {
    UserForm
  }
}
</script>


// WEBPACK FOOTER //
// UserDetails.vue?517f59b4